import React from 'react';
import styles from "../Login/Login.module.css";
import {Box, Typography} from "@mui/material";
import BackToLoginImage from "../../resources/Login/back_to_login_image.png";
import {useNavigate} from "react-router-dom";

const LoginRequiredPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.Login} data-testid="403">
      <section id="AccountTitle" className={styles.LoginTitle}>
        <Typography variant="h1">Please Login</Typography>
      </section>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <br/><br/><br/><br/><br/>
        <Box sx={{ width: '80%', maxWidth: 800, textAlign: 'center' }}>
          <br/><br/><br/>
          <Typography variant="h4" gutterBottom>You need to be logged in to access this page.</Typography>
          <br/>
          <img src={BackToLoginImage} alt="login"/>
          <br/><br/>
          <button className={`PrimaryButton ${styles.LoginButton}`} onClick={() => navigate("/login")}>Back to login</button>
          <br/><br/><br/><br/><br/><br/>
        </Box>
      </div>
    </div>
  );
};

export default LoginRequiredPage;
